import { Check } from "lucide-react";

/** Round selection control with an enlarged touch target, per UI/UX STANDARD.md Rule 5. */
export function SelectionCheckbox({
  selected,
  onChange,
  label,
  className,
}: {
  selected: boolean;
  onChange: () => void;
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      aria-label={label}
      title={label}
      onClick={(e) => {
        // Stops a checkbox click from also bubbling to a row-level click
        // handler (e.g. an item row's own "toggle on any click while
        // selecting" logic), which would otherwise double-toggle.
        e.stopPropagation();
        onChange();
      }}
      className={[
        "relative flex size-5 shrink-0 items-center justify-center rounded-full border-2 transition",
        "after:absolute after:-inset-0.5 after:content-[''] [@media(pointer:coarse)]:after:-inset-3",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40",
        selected ? "border-brand-600 bg-brand-600 text-white" : "border-line bg-white",
        className ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {selected ? <Check size={12} aria-hidden="true" /> : null}
    </button>
  );
}
